import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={15}
      height={14}
      viewBox="0 0 15 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M2.516 11.437a.5.5 0 00.5.5h8.968a.5.5 0 00.5-.5v-3.64a4.984 4.984 0 10-9.968 0v3.64zm1.125-3.64a3.86 3.86 0 017.718 0v3.015H5.812V8.14a.157.157 0 00-.156-.156H4.97a.157.157 0 00-.157.156v2.672H3.641V7.796zM2.889 3.85l.619-.619a.125.125 0 000-.177l-1.061-1.06a.125.125 0 00-.177 0l-.618.618a.125.125 0 000 .177l1.06 1.06a.125.125 0 00.177 0zm10.463-1.238l-.62-.619a.125.125 0 00-.176 0l-1.06 1.061a.125.125 0 000 .177l.618.619a.125.125 0 00.177 0l1.06-1.061a.125.125 0 000-.177zM12.5 12.937h-10a.5.5 0 00-.5.5v.375c0 .068.056.125.125.125h10.75a.125.125 0 00.125-.125v-.375a.5.5 0 00-.5-.5zM7.062 1.812h.875a.125.125 0 00.125-.125v-1.5a.125.125 0 00-.125-.125h-.875a.125.125 0 00-.125.125v1.5c0 .068.057.125.125.125z"
        fill="#E60049"
      />
    </Svg>
  );
}

export default SvgComponent;
